

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_zindex";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_zindex__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"zIndex_PAGE":"1","zIndex_NOTIFICATION":"4000","zIndex_COLLAPSE_STICKY":"1"}; 
export var vars = {}; 




